import { Card, CardContent, CardActions, Box, Typography, Button, Grid, LinearProgress, Skeleton, Tooltip } from "@mui/material"
import { Add, Article, Visibility } from "@mui/icons-material"
import { getDateAsPerFormat } from "../../_helpers/reusablefunctions/dateSetter"
import { SkeletonSection } from "../../_helpers/reusablefunctions/SkeletonCard"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"

const getCampaignProgress = (status) => {
  const statusMap = {
    UnderReview: 25,
    SongPromotionLive: 75,
    Completed: 100,
    Rejected: 0,
  }
  return statusMap[status] || 0
}

export const CampaignsSection = ({ campaigns, loading }) => {
  const history = useHistory()
  const userData = useSelector((state) => state.userData.userData);

  if (loading) {
    return (
      SkeletonSection()
    )
  }

  return (
    <Card sx={{ mb: 4 }}>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h5" fontWeight="bold">
            Campaigns({campaigns.length})
          </Typography>
          {/* <Button variant="contained" className="gn-actionbtn" startIcon={<Add />} onClick={() => history.push('/campaign/create')} sx={{ borderRadius: 2 }}>
            Create New Campaign
          </Button> */}
          {userData?.enable_distribution ? <a href="/campaign" className="gn-actionbtn-color ">
            View All Campaign
          </a> : null}
        </Box>


        {campaigns.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="h6" color="text.secondary">
              No campaigns found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Create your first campaign to get started
            </Typography>
          </Box>
        ) : (

          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" }, gap: 2 }}>
            {campaigns.slice(0, 3).map((campaign) => (
              <Box key={campaign.id}>
                <Card
                  sx={{
                    height: "100%",
                    transition: "transform 0.2s",
                    "&:hover": { transform: "translateY(-4px)" },
                  }}
                >
                  <CardContent>
                    {/* <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                      {campaign.campaignName}
                    </Typography> */}
                    <Tooltip title={campaign.campaignName} placement="top" arrow>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{
                          mb: 2,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "250px"
                        }}
                      >
                        {campaign.campaignName}
                      </Typography>
                    </Tooltip>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      Song Name: {campaign.songName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      End Date: {getDateAsPerFormat(campaign?.endDate, "dd/MM/yyyy")}
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                        <Typography variant="body2">Progress</Typography>
                        <Typography variant="body2">{getCampaignProgress(campaign.status)}%</Typography>
                      </Box>
                      <LinearProgress
                        variant="determinate"
                        value={getCampaignProgress(campaign.status)}
                        sx={{ height: 8, borderRadius: 4 }}
                      />
                    </Box>
                  </CardContent>
                  <CardActions>
                    <Button size="small" className="gn-actionbtn-color"
                      onClick={() => history.push({ pathname: '/campaign/view', state: campaign })} startIcon={<Visibility />}>
                      View Details
                    </Button>
                  </CardActions>
                </Card>
              </Box>
            ))}
          </Box>

        )}
      </CardContent>

    </Card>
  )
}
